import axios from "axios";
// List products with Api
export const GetCourseChild = async (course_id,language_id,jwt,user_id,courseLevel_father) => {

  let url = process.env.REACT_APP_ADMIN_API_URL + `/CourseLevelChild`
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'course_id': course_id,
    'language_id': language_id,
    "courseLevel_father":courseLevel_father,
    'user_id': user_id
  });
  try {
    const response = await axios.post(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};